import { defaultGenericMeta, GenericStateMeta } from "store/common";
import type { JsonPayload } from "store/payments/payments-state";

export type PaymentType = "standard" | "principal" | "escrow";
export type PaymentAmountType = "due_amount" | "loan_balance" | "other";

export enum CardType {
  MASTER_CARD = 1,
  VISA = 2,
  AMEX = 3,
  DISCOVER = 4,
  JCB = 5,
  EWALLET = 6,
  SAVINGS = 7,
}

export enum CardBinType {
  CREDIT = 1,
  DEBIT = 2,
}

export enum CurrencyCode {
  USD = "USD",
}

export interface BillingAddress {
  line1: string;
  line2?: string;
  city?: string;
  state?: string;
  country?: string;
  zip: string;
}

export interface CardDO {
  cardHolderName: string;
  tokenizedCardData: string;
  expirationDate: string;
  cvv2?: string;
  type?: string;
  cardType?: CardType;
  address: BillingAddress;
  lastFour?: string;
  authReferenceId?: string;
  cardBinType?: CardBinType;
}

export interface AchDO {
  bankAccountType: number; //checking: 1, savings: 2,
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  confirmAccountNo?: string;
}

export interface EWalletDO {
  walletType: number; //googlepay: 1, applePay: 2
}

export interface PaymentMethod
  extends Partial<AchDO>, Partial<CardDO>, Partial<EWalletDO> {
  paymentMethodType?: number; //ACH: 1, Card: 2, EWallet: 3,
  ack?: boolean;
  response?: any;
  paymentMethodName?: string;
  autoPay?: boolean;
  id?: number;
  colorClass?: string;
  jsonPayload?: JsonPayload;
  accountType?: string;
}

export interface PaymentMethodsState {
  meta: GenericStateMeta;
}

export const initialState: PaymentMethodsState = {
  meta: { ...defaultGenericMeta },
};

export interface PaymentMethodAuthRequest {
  paymentMethodAuthCardDto?: PaymentMethodAuthCard;
  paymentMethodAuthAchDto?: PaymentMethodAuthAch;
  authReferenceId?: string;
  clientId?: number;
  accountType?: string;
}

export interface PaymentMethodAuthCard {
  cardHolderName: string;
  cardToken: string;
  expirationDate: string;
  cvv2?: string;
  cardType?: CardType;
  address: BillingAddress;
  lastFour?: string;
}

export interface PaymentMethodAuthAch {
  routingNumber: string;
  accountNumber: string;
}

export interface PaymentMethodAuthResponse {
  cardBinType?: CardBinType;
  authReferenceId?: string;
}
